import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  fetchActiveForms,
  fetchActiveFormsAll,
  fetchForms,
  fetchScheduledForms,
  fetchOrganization,
  fetchOrgUsers,
  fetchPlannedForms,
  fetchPlannedFormsAll,
  fetchFilledFormsExtended,
  fetchArchivedForms,
  fetchSavedFormData,
  fetchFormsScheduledForFuture,
  fetchFilledFormData,
  fetchProteges,
  fetchAssignedScreenings,
} from "../redux/actions";
import {
  fetchOrganizationFutureTerms,
  fetchTermsAcceptedByUser,
} from "../redux/organization/actions";
import Can from "../components/can";
import { NavLink, Redirect } from "react-router-dom";
import { checkPermission } from "../rbac";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import { Box, Button } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import PageTitle from "../components/page-title";
import Duration from "duration";
import Loader from "../components/loader";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import TermsAcceptance from "../components/terms-acceptance";
import format from "date-fns/format";

const MuiNavLink = withStyles((theme) => ({
  root: {
    color: theme.palette.anchor.primary,
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.text.primary,
      textDecoration: "underline",
    },
  },
}))(Link);

const useStyles = makeStyles((theme) => ({
  closeIconOnTop: {
    "align-self": "flex-start",
  },
  fontSize: {
    "& .MuiAlert-icon": {
      fontSize: theme.typography.body1.iconSize,
    },
    fontSize: theme.typography.body1.fontSize,
  },
  buttonContrast: {
    backgroundColor: "black",
    border: `1px solid ${theme.palette.text.primary}`,
    color: theme.palette.text.primary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: "black",
    },
  },
  link: {
    color: theme.palette.anchor.primary,
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.text.primary,
      textDecoration: "underline",
    },
  },
}));

const Main = ({
  fetchOrgUsers,
  activeForms,
  plannedForms,
  archivedForms,
  savedForms,
  history,
  match,
  scheduledForFutureForms,
  allFilledForms,
}) => {
  const my = useSelector((state) => state.my);
  const roles = useSelector((state) => state.roles);
  const forms = useSelector((state) => state.orgForms);
  const termsAcceptedByUser = useSelector((s) => s.termsAcceptedByUser);
  const orgFutureTerms = useSelector((s) => s.orgFutureTerms);
  const fetchingOrgFutureTerms = useSelector((s) => s.fetchingOrgFutureTerms);
  const isUser = my?.user.authorities.localeCompare("ROLE_USER") === 0;
  const canFetchForms = checkPermission("forms:fetch", roles);

  const dispatch = useDispatch();

  const [archivedForm, setArchivedForm] = useState({});
  const filledFormsExtended = useSelector(
    (s) => archivedForm && s.filledFormsExtended[archivedForm.id]
  );
  const [initialization, setInitialization] = useState(true);

  const [
    openPlannedActiveFormsAlert,
    setOpenPlannedActiveFormsAlert,
  ] = useState(true);
  const [
    expandPlannedActiveFormsAlert,
    setExpandPlannedActiveFormsAlert,
  ] = useState(false);

  const [openSavedFormsAlert, setOpenSavedFormsAlert] = useState(true);
  const [expandSavedFormsAlert, setExpandSavedFormsAlert] = useState(false);

  const [openFilledFormsAlert, setOpenFilledFormsAlert] = useState(true);
  const [expandFilledFormsAlert, setExpandFilledFormsAlert] = useState(false);

  const [futureTermsAccepted, setFutureTermsAccepted] = useState(false);

  const globalTheme = useSelector((s) => s.globalTheme);
  const baseFontSize = useSelector((s) => s.baseFontSize);

  const classes = useStyles();

  useEffect(() => {
    if (checkPermission("admin:fetchOrgUsers", roles)) {
      fetchOrgUsers();
    }
  }, [roles]);

  // useEffect(() => {
  //   if (!isUser && canFetchForms) {
  //     dispatch(
  //       fetchForms({
  //         page: 0,
  //         pageSize: 100,
  //       })
  //     );
  //     dispatch(fetchScheduledForms());
  //   }
  // }, [isUser, canFetchForms]);

  useEffect(() => {
    if (checkPermission("admin:fetchOrgReports", roles)) {
    }
  }, [roles]);

  useEffect(() => {
    if (isUser) {
      // dispatch(fetchAssignedScreenings());
      dispatch(fetchProteges({ page: 0, pageSize: 500 }));
      dispatch(fetchActiveFormsAll());
      dispatch(fetchPlannedFormsAll());
      dispatch(
        fetchArchivedForms({
          page: 0,
          pageSize: 10,
        })
      );
      dispatch(
        fetchSavedFormData({
          page: 0,
          pageSize: 10,
        })
      );
      dispatch(
        fetchFormsScheduledForFuture({
          page: 0,
          pageSize: 10,
        })
      );
      dispatch(
        fetchFilledFormData({
          page: 0,
          pageSize: 10,
        })
      );
    }
  }, []);

  useEffect(() => {
    let plannedActiveForms = plannedForms
      ? plannedForms.filter(
          ({ form, endDate }) =>
            form.status === "ACTIVE" &&
            new Duration(new Date(), new Date(endDate)).seconds > 0
        )
      : [];

    plannedActiveForms = plannedActiveForms.filter(
      ({ endDate }) => new Duration(new Date(), new Date(endDate)).seconds > 0
    );

    if (plannedForms && activeForms) {
      // setInitialization(true);
      if (
        activeForms?.length === 1 &&
        plannedActiveForms?.length === 0 &&
        my.user.authorities.localeCompare("ROLE_USER") === 0
      ) {
        setTimeout(() => {
          // setInitialization(false);
          history.push(`/formdata/add/${activeForms[0].id}`);
        }, 1000);
      } else if (
        activeForms?.length === 0 &&
        plannedActiveForms?.length === 1 &&
        plannedActiveForms.filter(
          ({ endDate }) =>
            new Duration(new Date(), new Date(endDate)).seconds > 0
        ).length === 1 &&
        my.user.authorities.localeCompare("ROLE_USER") === 0
      ) {
        setTimeout(() => {
          // setInitialization(false);
          history.push({
            pathname: `/formdata/fill-scheduled-test/${plannedActiveForms[0].form.id}/${plannedActiveForms[0].id}`,
            state: { endDate: plannedActiveForms[0].endDate },
          });
        }, 1000);
      }
      setTimeout(() => {
        setInitialization(false);
      }, 1000);
    }

    if (
      plannedActiveForms?.length === 0 &&
      activeForms?.length === 0 &&
      archivedForms?.filter(({ status }) => status === "ACTIVE").length === 1
    ) {
      setArchivedForm(
        archivedForms?.filter(({ status }) => status === "ACTIVE")[0]
      );
      dispatch(
        fetchFilledFormsExtended(
          archivedForms?.filter(({ status }) => status === "ACTIVE")[0].id,
          {
            sort: `completedAt`,
          }
        )
      );
    }
  }, [activeForms, plannedForms, archivedForms]);

  useEffect(() => {
    if (isUser && !orgFutureTerms && !fetchingOrgFutureTerms) {
      dispatch(fetchOrganizationFutureTerms());
    }
  }, [isUser]);

  useEffect(() => {
    isUser && !termsAcceptedByUser && dispatch(fetchTermsAcceptedByUser());
  }, [isUser]);

  useEffect(() => {
    if (isUser && termsAcceptedByUser && orgFutureTerms) {
      const founded = termsAcceptedByUser.find(
        ({ terms }) => terms.id === orgFutureTerms.id
      );
      if (founded && !founded.revokedAt) {
        setFutureTermsAccepted(true);
      } else {
        setFutureTermsAccepted(false);
      }
    }
  }, [termsAcceptedByUser, orgFutureTerms]);

  function parseISOString(s) {
    let date = new Date(s);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    let hour = date.getHours();
    // let hour =
    //   date.getHours().toString().length === 1
    //     ? "0" + date.getHours()
    //     : date.getHours();
    let minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        {
          <strong
            style={{ color: "inherit" }}
          >{`${dt}-${month}-${year}`}</strong>
        }{" "}
        godzina:{" "}
        {<strong style={{ color: "inherit" }}>{`${hour}:${minutes}`}</strong>}
      </>
    );
  }

  var remainingActiveForms;
  if (plannedForms?.length < 3) {
    remainingActiveForms = activeForms?.slice(
      3 - plannedForms.length,
      activeForms.length
    );
  } else {
    remainingActiveForms = activeForms;
  }

  const loggedUserMainPage = () => (
    <Box>
      {initialization && isUser ? (
        <Box p={3}>
          {<Loader loading={true} text="Pobieranie formularzy" />}
        </Box>
      ) : (
        <Box p={1}>
          <PageTitle title="Dzisiejsze akcje" />

          {!my.user.activated && (
            <Box mt={1} key={"activateAccountAlert"}>
              {globalTheme === "high-contrast" ? (
                <Alert
                  icon={<PersonIcon />}
                  severity="warning"
                  style={{
                    backgroundColor: "#000000",
                    border: "1px solid #ffff00",
                    color: "#ffff00",
                  }}
                >
                  Konto nie zostało aktywowane - prosimy kliknąć w link
                  aktywacyjny wysłany w mailu powitalnym.
                </Alert>
              ) : (
                <Alert icon={<PersonIcon />} severity="warning">
                  Konto nie zostało aktywowane - prosimy kliknąć w link
                  aktywacyjny wysłany w mailu powitalnym.
                </Alert>
              )}
            </Box>
          )}

          {!my.firstName && (
            <Box mt={1}>
              <Alert icon={<PersonIcon />} severity="warning">
                Prosimy o wypełnienie profilu.{" "}
                <MuiNavLink href="/profile">PRZEJDŹ DO PROFILU</MuiNavLink>
              </Alert>
            </Box>
          )}

          {orgFutureTerms && !futureTermsAccepted && (
            <Box mt={1}>
              <Alert severity="warning">
                {`Regulamin zostanie zmieniony w dniu ${format(
                  new Date(orgFutureTerms.activeSince),
                  "yyyy-MM-dd"
                )}. Prosimy o zapoznanie
                              się i akceptację warunków.`}

                <TermsAcceptance
                  terms={orgFutureTerms}
                  acceptance={true}
                  future={true}
                ></TermsAcceptance>
              </Alert>
            </Box>
          )}

          {scheduledForFutureForms?.length > 0 && isUser && (
            <Box mt={1}>
              <Alert severity="warning" className={classes.fontSize}>
                <AlertTitle>
                  Zbliżające się formularze do wypełnienia
                </AlertTitle>
                <ul
                  style={{ listStyleType: "circle", marginLeft: "15px" }}
                ></ul>
                {scheduledForFutureForms?.map(
                  ({ id, form, startDate }, index) => (
                    <li key={index}>
                      <span style={{ fontWeight: "bold" }}>{form.name} </span>
                      {parseISOString(startDate)}
                    </li>
                  )
                )}
              </Alert>
            </Box>
          )}

          {(plannedForms?.length > 0 || activeForms?.length > 0) && isUser && (
            <Box mt={1}>
              <Collapse in={openPlannedActiveFormsAlert}>
                <Alert
                  style={{
                    marginBottom: "0px",
                    // backgroundColor: "black",
                    // border: "1px solid yellow",
                  }}
                  // className={classes.fontSize}
                  severity="error"
                  action={
                    <IconButton
                      className={classes.closeIconOnTop}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpenPlannedActiveFormsAlert(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  Twoje formularze do wypełnienia:
                  <span>
                    <ul style={{ listStyleType: "circle", marginLeft: "15px" }}>
                      {plannedForms
                        ?.slice(0, 3)
                        .map(({ id, form, endDate }, index) => (
                          <li key={index}>
                            <span style={{ fontWeight: "bold" }}>
                              {form.name}{" "}
                            </span>
                            {new Duration(new Date(), new Date(endDate))
                              .seconds < 0 ? (
                              <span>Czas na wypełnienie minął</span>
                            ) : (
                              <NavLink
                                className={classes.link}
                                to={{
                                  pathname: `/formdata/fill-scheduled-test/${form.id}/${id}`,
                                  state: { endDate },
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WYPEŁNIJ
                              </NavLink>
                            )}
                          </li>
                        ))}
                      {plannedForms?.length < 3 &&
                        activeForms
                          ?.slice(0, 3 - plannedForms.length)
                          .map((form, index) => (
                            <li key={index}>
                              <span style={{ fontWeight: "bold" }}>
                                {form.name}{" "}
                              </span>
                              <NavLink
                                className={classes.link}
                                to={{
                                  pathname: `/formdata/add/${form.id}`,
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WYPEŁNIJ
                              </NavLink>
                            </li>
                          ))}
                      <Collapse in={expandPlannedActiveFormsAlert}>
                        {plannedForms
                          ?.slice(3, plannedForms.length)
                          .map(({ id, form, endDate }, index) => (
                            <li key={index}>
                              <span style={{ fontWeight: "bold" }}>
                                {form.name}{" "}
                              </span>
                              {new Duration(new Date(), new Date(endDate))
                                .seconds < 0 ? (
                                <span>Czas na wypełnienie minął</span>
                              ) : (
                                <NavLink
                                  className={classes.link}
                                  to={{
                                    pathname: `/formdata/fill-scheduled-test/${form.id}/${id}`,
                                  }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  WYPEŁNIJ
                                </NavLink>
                              )}
                            </li>
                          ))}
                        {remainingActiveForms?.map((form, index) => (
                          <li key={index}>
                            <span style={{ fontWeight: "bold" }}>
                              {form.name}{" "}
                            </span>

                            <NavLink
                              className={classes.link}
                              to={{
                                pathname: `/formdata/add/${form.id}`,
                              }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              WYPEŁNIJ
                            </NavLink>
                          </li>
                        ))}
                      </Collapse>
                    </ul>
                    {(plannedForms?.length > 3 ||
                      plannedForms?.length + activeForms?.length > 3) && (
                      <IconButton
                        className={classes.fontSize}
                        aria-label="close"
                        color="inherit"
                        size="small"
                        outline="true"
                        onClick={() => {
                          setExpandPlannedActiveFormsAlert(
                            !expandPlannedActiveFormsAlert
                          );
                        }}
                      >
                        {!expandPlannedActiveFormsAlert ? (
                          <ExpandMoreIcon fontSize="large" fontSize="inherit" />
                        ) : (
                          <ExpandLessIcon fontSize="large" fontSize="inherit" />
                        )}
                        <p style={{ fontSize: "0.8em" }}>
                          {!expandPlannedActiveFormsAlert
                            ? `Rozwiń listę`
                            : `Zwiń listę`}
                        </p>
                      </IconButton>
                    )}
                  </span>
                </Alert>
              </Collapse>
            </Box>
          )}
          {savedForms && savedForms?.length > 0 && isUser && (
            <Box mt={1}>
              <Collapse in={openSavedFormsAlert}>
                <Alert
                  style={{ marginBottom: "0px" }}
                  className={classes.fontSize}
                  severity="success"
                  action={
                    <IconButton
                      className={classes.closeIconOnTop}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpenSavedFormsAlert(!openSavedFormsAlert);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  Twoje zapisane formularze:
                  <ul style={{ listStyleType: "circle", marginLeft: "15px" }}>
                    {savedForms?.slice(0, 3).map((formData, index) => (
                      <li key={index}>
                        <span style={{ fontWeight: "bold" }}>
                          {formData.form.name}{" "}
                        </span>
                        <MuiNavLink
                          href={`/formdata/edit/${formData.form.id}/${formData.id}`}
                        >
                          EDYTUJ
                        </MuiNavLink>
                      </li>
                    ))}
                    <Collapse in={expandSavedFormsAlert}>
                      {savedForms
                        ?.slice(3, savedForms.length)
                        .map((formData, index) => (
                          <li key={index}>
                            <span style={{ fontWeight: "bold" }}>
                              {formData.form.name}{" "}
                            </span>
                            <a
                              className={`${
                                globalTheme === "high-contrast" &&
                                classes.aalertHighContrast
                              } ${classes.fontSize}`}
                              onClick={() => {
                                history.push(
                                  `/formdata/edit/${formData.form.id}/${formData.id}`
                                );
                              }}
                            >
                              EDYTUJ
                            </a>
                          </li>
                        ))}
                    </Collapse>
                  </ul>
                  {savedForms?.length > 3 && (
                    <IconButton
                      className={classes.fontSize}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setExpandSavedFormsAlert(!expandSavedFormsAlert);
                      }}
                    >
                      {!expandSavedFormsAlert ? (
                        <ExpandMoreIcon fontSize="large" fontSize="inherit" />
                      ) : (
                        <ExpandLessIcon fontSize="large" fontSize="inherit" />
                      )}
                      <p style={{ fontSize: "0.8em" }}>
                        {!expandFilledFormsAlert
                          ? `Rozwiń listę`
                          : `Zwiń listę`}
                      </p>
                    </IconButton>
                  )}
                </Alert>
              </Collapse>
            </Box>
          )}
          {allFilledForms?.length > 0 && isUser && (
            <Box mt={1}>
              <Collapse in={openFilledFormsAlert}>
                <Alert
                  className={classes.fontSize}
                  style={{ marginBottom: "0px" }}
                  severity="success"
                  action={
                    <IconButton
                      className={classes.closeIconOnTop}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpenFilledFormsAlert(!openFilledFormsAlert);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  Twoje wypełnione formularze:
                  <ul style={{ listStyleType: "circle", marginLeft: "15px" }}>
                    {allFilledForms
                      .sort(function (a, b) {
                        return a.completedAt < b.completedAt
                          ? -1
                          : a.completedAt > b.completedAt
                          ? 1
                          : 0;
                      })
                      .reverse()
                      .slice(0, 3)
                      .map(({ form, completedAt, id }, index) => (
                        <li key={index} style={{ marginBottom: "5px" }}>
                          <span>
                            Nazwa formularza:{" "}
                            {
                              <strong style={{ color: "inherit" }}>
                                {form.name}
                              </strong>
                            }{" "}
                          </span>
                          <br />
                          <span>
                            Data wypełnienia: {parseISOString(completedAt)}
                          </span>
                          <br />
                          <MuiNavLink href={`/formdata/${id}`}>
                            Zobacz szczegóły wypełnienia
                          </MuiNavLink>
                          <br />
                        </li>
                      ))}
                    <Collapse in={expandFilledFormsAlert}>
                      {allFilledForms
                        .sort(function (a, b) {
                          return a.completedAt < b.completedAt
                            ? -1
                            : a.completedAt > b.completedAt
                            ? 1
                            : 0;
                        })
                        .reverse()
                        .slice(3, allFilledForms.length)
                        .map(({ form, completedAt, id }, index) => (
                          <li key={index} style={{ marginBottom: "5px" }}>
                            <span>
                              Nazwa formularza:{" "}
                              {
                                <strong style={{ color: "inherit" }}>
                                  {form.name}
                                </strong>
                              }{" "}
                            </span>
                            <br />
                            <span>
                              Data wypełnienia: {parseISOString(completedAt)}
                            </span>
                            <br />
                            <MuiNavLink href={`/formdata/${id}`}>
                              Zobacz szczegóły wypełnienia
                            </MuiNavLink>
                            <br />
                          </li>
                        ))}{" "}
                    </Collapse>
                  </ul>
                  {allFilledForms?.length > 3 && (
                    <IconButton
                      className={classes.fontSize}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setExpandFilledFormsAlert(!expandFilledFormsAlert);
                      }}
                    >
                      {!expandFilledFormsAlert ? (
                        <ExpandMoreIcon fontSize="large" fontSize="inherit" />
                      ) : (
                        <ExpandLessIcon fontSize="large" fontSize="inherit" />
                      )}
                      <p style={{ fontSize: "0.8em" }}>
                        {!expandFilledFormsAlert
                          ? `Rozwiń listę`
                          : `Zwiń listę`}
                      </p>
                    </IconButton>
                  )}
                </Alert>
              </Collapse>
            </Box>
          )}
          {my.firstName &&
            plannedForms?.length === 0 &&
            activeForms?.length === 0 &&
            archivedForms?.length === 0 &&
            my.user.activated && <span>Brak akcji</span>}
        </Box>
      )}
    </Box>
  );

  return (
    <>
      <Can
        permission="main:view"
        ok={loggedUserMainPage}
        not={() => <Redirect to="/login" />}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  orgUsers: state.orgUsers,
  orgReports: state.orgReports,
  organization: state.organization,
  activeForms: state.activeFormsAll,
  plannedForms: state.plannedFormsAll,
  archivedForms: state.archivedForms,
  savedForms: state.savedForms,
  scheduledForFutureForms: state.scheduledForFutureForms,
  allFilledForms: state.allFilledForms,
});

const mapDispatchToProps = (dispatch) => ({
  fetchOrgUsers: () => dispatch(fetchOrgUsers()),
  fetchForms: () => dispatch(fetchForms()),
  fetchOrganization: () => dispatch(fetchOrganization()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
